import React, { useState, useContext} from 'react';
import {
  SafeAreaView,
  StyleSheet,
  View,
  Text,
  TextInput,
  Button,
  Image,
  Alert,
  TouchableOpacity,
  Modal,
  ScrollView,
} from 'react-native';
import firebase from 'firebase';
import { AuthContext } from '../Contexts/ContextUsuario';
import { ProductsContext } from '../Contexts/ContextProdutos';
import { EnvioContext } from '../Contexts/ContextEnvio'

var app = firebase.app();

var db = app.database();

var valor_final = 0
var produtos = []


var val

function salvaDatabase(element, index, array) {
  valor_final = valor_final + element.valor
  produtos.push(element.nome)

}
var data = new Date().toDateString()
var hora = new Date().getHours()
var min = new Date().getMinutes();


const TelaEnvio = (props) => {
  const { state, actions } = useContext(AuthContext);
  const { estado } = useContext(ProductsContext);
  const { stateEnvio, actionsEnvio } = useContext(EnvioContext);
  
  function Nice(){
    console.log('Nice()')
    db.ref('usuarios/' + state.user.name + '/pedido').once('value').then(async (snapshot) => {
      val = await snapshot.val();
      var nomeUsuario = state.user.name.charAt(4) + state.user.name.charAt(5) + state.user.name.charAt(6) + state.user.name.charAt(7) 
      console.log(nomeUsuario)
      var n_pedido = parseInt(valor_final + nomeUsuario) * parseInt(min)


      console.log('val: ' + val)
      console.log("n_pedido: "+ n_pedido)

        estado.cart.products.forEach(salvaDatabase)

      function fazPedido(){
        if(state.user.saldo < valor_final){
          alert('Você não possui saldo suficiente para efetuar a compra.', 'Para adicionar saldo ao aplicativo entre em contato com a Cantina Santa Clara')
          props.navigation.navigate('PAGINA INICIAL')
          } else{
          function Noice(){

            db.ref('pedidos/' + n_pedido).update({
              numpedido: n_pedido,
              Valor: valor_final,
              Produtos: produtos.join(', '),
              Data: String(data + ` ${hora}:${min}`),
              Matrícula: state.user.name,
              Entrega: stateEnvio.envio.data
            })
    
            db.ref('usuarios/' + state.user.name + '/pedido/' + n_pedido).update({
              Valor: valor_final, 
              Produtos: produtos.join(', '),
              Data: String(data),
              N_pedido: n_pedido,
              Entrega: stateEnvio.envio.data
            })
    
            actions.setUser({
              numpedido: n_pedido,
              saldo: state.user.saldo - valor_final
            })
    
            db.ref('usuarios/' + state.user.name).update({
              saldo: state.user.saldo - valor_final
            })
            produtos = []
            valor_final = 0
            props.navigation.navigate('ENVIADO')

          }
          console.log(stateEnvio.envio.data)
          if(window.confirm(
            `Você tem certeza?\n\nPreço: R$${valor_final}\nProdutos: ${produtos.join(', ')}\nEntrega: ${stateEnvio.envio.data}\n\nAo clicar em \"OK\", seu pedido será enviado e o valor descontado de seu saldo. Essa ação é irreversível.`,
            ) ){
          // [
          //   {
          //     text: 'Confirmar',
          //       onPress: () => Noice(),
          //     },
          //     {
          //       text: 'Cancelar',
          //       onPress: () => {
          //         valor_final = 0
          //         produtos = []
          //         props.navigation.navigate('CARRINHO')
          //       },
          //       style: "cancel"
          //     }
          //   ],
          //   { cancelable: false }
            Noice()
          }else{
            valor_final = 0
            produtos = []
            props.navigation.navigate('CARRINHO')
          }
        }
      }
      var lenghtPedido = produtos.lenght

      if(lenghtPedido <= 0 || produtos == []){
        alert('Não é possível enviar um pedido vazio!', 'Adicione mais itens ao seu carrinho para enviar um pedido.')
        props.navigation.navigate('TELA INICIAL')
      } else{
          fazPedido()
        }
    })    
  }

  Nice()
 
  return (
    <View>
      <View style={design.centeredView}>
      </View>
    </View>
  );
};

const design = StyleSheet.create({
  centeredView: {
    height: '100%',
    width: '100%',

    backgroundColor: 'rgba(179, 179, 179, 255)',
  },

  textStyle: {
    color: 'white',
    fontWeight: 'bold',
    textAlign: 'center',
    fontSize: 25,
    marginTop: 20,
  },

  botão: {
    backgroundColor: 'rgba(255, 255, 255, 255)',
    borderRadius: 20,
    padding: 5,
    marginBottom: 30,
    marginTop: 20,
    marginHorizontal: 0,

  },
});

export default TelaEnvio;
